import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { GlobalConstantsChart, GlobalConstantsDom, GlobalFunctions } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';

import { ErgebnisGebaeude } from 'src/app/data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsDom } from 'src/app/immutable/constants-dom';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-chart-fb-je-tp',
  templateUrl: './chart-fb-je-tp.component.html',
  styleUrls: ['./chart-fb-je-tp.component.css'],
})
export class ChartFbJeTpComponent implements OnInit {
  @Input() isNetto!: boolean;

  private guid: string = Guid.create().toString();
  private ergebnisseSubscription!: Subscription;
  private chartInstance!: Chart;
  private isUpdated = false;

  constructor(public localService: LocalService) {}

  ngOnInit(): void {
    this.ergebnisseSubscription = this.localService.diagramErgebnisse.subscribe(
      (ergebnisse) => {
        if (ergebnisse) {
          this.createChart(ergebnisse.ergebnisGebaeudeList!);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.ergebnisseSubscription) {
      this.ergebnisseSubscription.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    if (!this.isUpdated) {
      const element = document.getElementById(ConstantsDom.DOM_CHART_FB_JE_TP);
      if (element) { 
        element.setAttribute(GlobalConstantsDom.DOM_ID, this.guid);
        this.isUpdated = true;
      }
    }
  }

  async createChart(ergebnisGebaeudeList: ErgebnisGebaeude[]) {
    await new Promise((f) => setTimeout(f, 1));

    if (this.localService.istGebaeude.value) return;

    let temp : ErgebnisGebaeude[] = 
    ergebnisGebaeudeList.length > 1 
        ? ergebnisGebaeudeList.slice(1) 
        : ergebnisGebaeudeList.slice(0, 1);

    let chartDataSets: any[] = [];

    if (temp.length !== 0) {
      const isNettoList = this.isNetto
        ? temp[0].ergebnisFlaechenJeTpNachFbKomplett
            .ergebnisFlaechenJeTpNachFkbNgfEinzelnList
        : temp[0].ergebnisFlaechenJeTpNachFbKomplett
            .ergebnisFlaechenJeTpNachFkbBgfEinzelnList;

      isNettoList.forEach((entry, i) => {
        let data: number[] = [];

        temp.forEach((entry2) => {
          const flaechenList = this.isNetto
            ? entry2.ergebnisFlaechenJeTpNachFbKomplett
                .ergebnisFlaechenJeTpNachFkbNgfEinzelnList
            : entry2.ergebnisFlaechenJeTpNachFbKomplett
                .ergebnisFlaechenJeTpNachFkbBgfEinzelnList;

          data.push(flaechenList[i].flaeche);
        });

        chartDataSets.push({
          label: entry.funktionsbereich,
          backgroundColor: entry.diagrammfarbe,
          data: data,
        });
      });
    }

    let titleText: string =
      ConstantsTexte.BRUTTOFLAECHEN_JE_TP_NACH_FKT;
    let seitenUeberschriftText: string = ConstantsTexte.FLAECHE_IN_M2_TP;
    if (this.isNetto)
      titleText = ConstantsTexte.NETTOFLAECHEN_JE_TP_NACH_FKT;

    if (this.chartInstance) { 
      this.chartInstance.destroy();
    }

    this.chartInstance = GlobalFunctions.getDiagramm(
      this.guid,
      Functions.getChartLabels(
        temp,
        this.localService.istGebaeude.value
      ),
      chartDataSets,
      titleText,
      seitenUeberschriftText,
      2,
      true,
      GlobalConstantsChart.FARBE_SCHWARZ
    );
  }
}
